import { notification } from '@/plugins/helpers'
import { AlertTypes } from '../plugins/alerts_types'

export default {
  data: () => ({
    hasVaduPermission: false
  }),
  async mounted () {
    await this.getVaduPermissions()
  },
  methods: {
    async getVaduPermissions () {
      try {
        const response = await this.$http.get('/painel/perfis-permissao-vadu')
        this.hasVaduPermission = response.data.hasPermission
      } catch (error) {
        notification(AlertTypes.ERROR, 'Erro ao obter permissões do Vadu:', error)
        this.hasVaduPermission = false
      }
    }
  }
}
